import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import element1 from '../../assets/blog-shape1.png';
import element2 from '../../assets/blog-shape2.png';
import css from './BlogPage.module.css';

function SectionHero() {
  return (
    <div className={css.heroContainer}>
      <img className={css.shape1} src={element1} alt="element" />
      <img className={css.shape2} src={element2} alt="element" />
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1>
            <FormattedMessage id="BlogPage.heading1" />
          </h1>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
